import React from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from 'core/data/routes/all_routes';
import useFetch from 'core/hooks/api/useFetch';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';


const formatCategoryValue = (value) => {
    return value.replace(/[-_]/g, ' ').replace(/\b\w/g, char => char.toUpperCase()).toLowerCase().replace(/^\w/, char => char.toUpperCase());
};

const CategoryV1 = () => {
    const { data: homeCategories, error } = useFetch(API_ENDPOINTS.FILTER + "/search/home_category");

    if (error) return <div>Error: {error.message}</div>;

    return (
        <div className="ltn__category-area ltn__product-gutter section-bg-1--- pt-115 pb-90 go-top">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area ltn__section-title-2--- text-center">
                            <h5 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                            ¿Listo para transformar tu espacio?
                            </h5>
                            <h1 className="section-title">DALE VIDA A TUS PROYECTOS</h1>
                        </div>
                    </div>
                </div>
                <div className="row ltn__category-slider-active--- slick-arrow-1 justify-content-center">
                    {homeCategories && homeCategories[0]?.options?.map((category) => (
                        <div key={category.id} className="col-lg-3 col-md-4 col-sm-6 col-6">
                            <div className="ltn__category-item ltn__category-item-5 text-center">
                                <Link className="px-3" to={`${all_routes.product}?home_category=${category.value}`}>
                                    <span className="category-icon">
                                        <i className={category.icon}></i>
                                    </span>
                                    <span className="category-title text-truncate">{formatCategoryValue(category.value)}</span>
                                    <span className="category-btn">
                                        <i className="flaticon-right-arrow" />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CategoryV1;